import { gql, useQuery } from '@apollo/client';

export const queryAutomationTicketByTaskId = gql`
  query Task($id: ID!) {
    task(id: $id) {
      automationTicket {
        id
        ticketCode
        status
        customCode
        automationTicketProperties {
          id
          automationPropertyId
          answer {
            id
            formatContent
            content
            answerOptions
            question {
              name
            }
          }
        }
      }
    }
  }
`;

export interface AutomationTicketProperty {
  id: string;
  automationPropertyId: string;
  answer: {
    id: string;
    formatContent: string;
    content: string;
    answerOptions: string[];
  };
}

export interface AutomationTicket {
  id: string;
  ticketCode: string;
  status: string;
  customCode: string;
  automationTicketProperties: AutomationTicketProperty[];
}

export interface AutomationTicketResponse {
  task: {
    automationTicket: AutomationTicket;
  };
}

export const useAutomationTicket = (taskId?: string) => {
  const { data, loading, error } = useQuery<AutomationTicketResponse>(
    queryAutomationTicketByTaskId,
    {
      variables: { id: taskId },
      skip: !taskId,
    },
  );

  return {
    automationTicket: data?.task?.automationTicket,
    loading,
    error,
  };
};
